export default function EMSuccessionPlanningDirective() {
  return {
    template: require('./em-succession-planning.html'),
    controller: 'EMSuccessionPlanningController',
    controllerAs: 'emSuccessionPlanningVM',
    scope: {
      successorOptions: '<',
      successions: '='
    },
    bindToController: true,
    replace: true,
  };
}
